/**
 * Telemetry & Performance Monitoring Module Public API
 */

import { telemetryService } from './telemetryService';
import { initWebVitals } from './webVitals';
import { initCrashReporter, reportReactCrash } from './crashReporter';
import { navigationTracker } from './navigationTracker';
import { nativeTelemetry } from './nativeTelemetry';

export * from './telemetryTypes';
export * from './telemetryService';
export * from './webVitals';
export * from './crashReporter';
export * from './navigationTracker';
export * from './nativeTelemetry';

/**
 * Global Telemetry Initializer
 * Starts Web Vitals, crash interception, navigation tracking, and thread monitoring.
 */
export function initTelemetry(): void {
  initCrashReporter();
  initWebVitals();
  navigationTracker.recordInitialPageLoad();
  nativeTelemetry.startThreadWatcher();
  nativeTelemetry.trackStartup({});
}
